export default __webpack_public_path__ + "static/media/logo-google-play.2cb7aa9c.svg";